function getReputationState(state) {
  return {
    reputationLevel: state.score.reputationLevel,
    responseRate: state.score.responseRate,
    publications: state.score.publications,
    permanence: state.score.permanence,
    error: state.score.error,
    loading: state.score.loading,
    mainReputationLevel: state.score.mainReputationLevel
  };
}

export { getReputationState };
